<template>
    <div class="setting-component">
        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
                <div class="nav-tree">
                    <el-button @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('general_add')}} {{btnText}}</el-button>
                </div>
                <el-table
                        max-height="650"
                        :data="tableData"
                        :empty-text="$t('general_noData')"
                        style="width: 100%">
                    <el-table-column
                      label="ID"
                      type="index"
                      width="50">
                    </el-table-column>
                    <el-table-column
                            prop="no"
                            sortable
                            label="#"
                            width="80">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            :label="$t('settings_progress_notes_activities_name')">
                    </el-table-column>
                    <el-table-column
                            prop="createDate"
                            :label="$t('settings_progress_notes_activities_createDate')"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            width="120"
                            :label="$t('settings_progress_notes_activities_operations')">
                        <template slot-scope="scope">
                            <el-button
                                        size="mini"
                                        type="primary"
                                        plain
                                        icon="el-icon-edit"
                                        @click="handleEdit(scope.$index, scope.row)"></el-button>
                            <el-button
                                        size="mini"
                                        type="danger"
                                        plain
                                        icon="el-icon-delete"
                                        @click="handleDelete(scope.$index, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- add -->
        <sweet-modal ref="openModal" :title="`${$t('general_add')} ${btnText}`" class="modal" v-on:close="closeModal">
          <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="no">
                  <el-input type="number" label="#" v-model="form.no"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="name">
                  <el-input :label="$t('settings_progress_notes_activities_name')" v-model="form.name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item class="modal__btn">
              <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
              <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
            </el-form-item>
          </el-form>
        </sweet-modal>
        <!-- edit -->
        <sweet-modal ref="openModalEdit" :title="`Edit ${btnText}`" class="modal" v-on:close="closeModalEdit">
            <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item prop="no">
                      <el-input type="number" label="#" v-model="formEdit.no"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="name">
                      <el-input :label="$t('settings_progress_notes_activities_name')" v-model="formEdit.name"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <sweet-modal ref="confirmation" :title="`Delete ` + btnText">
            Are you sure you want to delete this {{btnText}}?
            <template slot="box-action">
                <el-button class="button" @click="deleteConfirm">Delete {{btnText}}</el-button> &nbsp;
            </template>
        </sweet-modal>
    </div>
</template>

<script>
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'

  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: 'setting-table',
    components: {
      // Header,
      // Menu,
      // AgGridVue,
      SweetModal,

    },
    beforeCreate() {
    },
    beforeMount() {

    },
    computed: {

    },
    mounted(){

    },
    data() {
      return {
        paleceholderText: this.$i18n.t('settings_progress_notes_activities_activity'),
        btnText: this.$i18n.t('settings_progress_notes_activities_activity'),
        tableData: [],
        selectedRowId: '',
        moment:moment,
        state: 'projectTaskExpenseCategories',
        form:{
          no: '',
          name: ''
        },
        formEdit:{
          no: '',
          name: ''
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          no: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesEdit: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          no: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
      }
    },
    methods: {
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      loadList(state){
        let loader = this.$loading.show();
        this.state = state
        if(state === 'projectTaskExpenseCategories'){
          this.btnText = 'Category'
          this.paleceholderText = 'Category/Account'
        }else if(state === 'projectTaskProgressActivities'){
          this.btnText = this.$i18n.t('settings_progress_notes_activities_activity')
          this.paleceholderText = this.$i18n.t('settings_progress_notes_activities_activity')
        }else if(state === 'projectTaskProgressAssignments'){
          this.btnText = this.$i18n.t('settings_progress_notes_assignments_assigment')
          this.paleceholderText = this.$i18n.t('settings_progress_notes_assignments_assigment')
        }else if(state === 'projectTaskExpsensePaymentMethods'){
          this.btnText = this.$i18n.t('settings_accountThink_paymentMethods_paymentMethod')
          this.paleceholderText = this.$i18n.t('settings_accountThink_paymentMethods_paymentMethod')
        }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${state}/list?companyId=${this.$route.query.companyId}`)
            .then(response => {
              this.tableData = response.data.list
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
      },
      openModalAdd(){
        this.$refs.openModal.open()
      },
      openModalEdit(){

      },
      openModalDelete(){

      },
      addItem(form){
        this.$refs[form].validate((valid) => {
            if (valid) {
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/${this.state}/create?companyId=${this.$route.query.companyId}`, this.form)
                .then(response => {
                  this.$refs.openModal.close()
                  this.loadList(this.state)
                })
                .catch(error => {
                  console.log('An error occurred:', error);
                });
            }else {
              console.log('error submit!!');
              return false;
            }
        });
      },
      closeModal(){
    this.form.no = ''
    this.form.name = ''
    this.$refs['form'].resetFields();
      },
      closeModalEdit(){
    this.formEdit.no = ''
    this.formEdit.name = ''
    this.$refs['formEdit'].resetFields();
      },
      handleEdit(index, row) {
        this.selectedRowId = row.id
        let loader = this.$loading.show();
        let Id = 'projectTaskExpenseCategoryId'
        if(this.state === 'projectTaskExpenseCategories'){
          Id = 'projectTaskExpenseCategoryId'
        }else if(this.state === 'projectTaskProgressActivities'){
          Id = 'projectTaskProgressActivityId'
        }else if(this.state === 'projectTaskProgressAssignments'){
          Id = 'projectTaskProgressAssignmentId'
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/item?companyId=${this.$route.query.companyId}&${Id}=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.name = response.data.item.name
            this.formEdit.no = response.data.item.no
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
            if (valid) {
        let loader = this.$loading.show();
        let Id = 'projectTaskExpenseCategoryId'
        if(this.state === 'projectTaskExpenseCategories'){
          Id = 'projectTaskExpenseCategoryId'
        }else if(this.state === 'projectTaskProgressActivities'){
          Id = 'projectTaskProgressActivityId'
        }else if(this.state === 'projectTaskProgressAssignments'){
          Id = 'projectTaskProgressAssignmentId'
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/update?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`, this.formEdit)
          .then(response => {
            this.$refs.openModalEdit.close()
            this.loadList(this.state)
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
            }else {
              console.log('error submit!!');
              return false;
            }
        });
      },
      handleDelete(index, row) {
        console.log(row.id)
        // this.$refs.confirmation.open()
        this.selectedRowId = row.id
        console.log(row)

        this.$confirm('This will permanently delete the vendor. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let Id = 'projectTaskExpenseCategoryId'
          if(this.state === 'projectTaskExpenseCategories'){
            Id = 'projectTaskExpenseCategoryId'
          }else if(this.state === 'projectTaskProgressActivities'){
            Id = 'projectTaskProgressActivityId'
          }else if(this.state === 'projectTaskProgressAssignments'){
            Id = 'projectTaskProgressAssignmentId'
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/${this.state}/delete?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`)
            .then(response => {
              this.$refs.confirmation.close()
              this.loadList(this.state)
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      deleteConfirm(){
        let Id = 'projectTaskExpenseCategoryId'
        if(this.state === 'projectTaskExpenseCategories'){
          Id = 'projectTaskExpenseCategoryId'
        }else if(this.state === 'projectTaskProgressActivities'){
          Id = 'projectTaskProgressActivityId'
        }else if(this.state === 'projectTaskProgressAssignments'){
          Id = 'projectTaskProgressAssignmentId'
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${this.state}/delete?companyId=${this.$route.query.companyId}&${Id}=${this.selectedRowId}`)
          .then(response => {
            this.$refs.confirmation.close()
            this.loadList(this.state)
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      showMenu() {
        this.open = true
        console.log('---', this.open);
      },
      hideMenu() {
        this.open = false
        console.log('---', this.open);
      },
      companyName(name) {
        this.companyNameSelect = name
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
    watch:{
      tableData(val){
        val.forEach(i =>{
          i.createDate = moment(i.createDate.toString(), 'X').format('D MMM YY')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .sweet-modal-overlay{
        z-index:1000;
    }
</style>

<style>

</style>
